import styles from './render-back.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { IconButton } from '../../design-system/buttons/icon-button';

export const RenderBack = ({ close = null, className, disabled = false }) => {
  const lang = useSelector(getLang('BACK_BUTTON'));

  return (
    <div className={classNames(styles.closeButtonWrapper, className)}>
      {close && (
        <IconButton
          onClick={close}
          label={lang.TEXT}
          showTooltip={true}
          type="button"
          disabled={disabled}>
          <FontAwesomeIcon icon={faCircleArrowLeft} className={styles.backArrow} />
        </IconButton>
      )}
    </div>
  );
};
